import * as Joi from "joi";
import i18n from "i18n/index";

export const SERVICEPOINT_SCHEMA = Joi.object({
    name: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Full Name"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    address: Joi.object().keys({
        description: Joi.string()
            .empty('')
            .label(i18n.t("Description"))
            .required()
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            }),
        coords: Joi.object().keys({
            latitude: Joi.number().min(-90).max(90).required(),
            longitude: Joi.number().min(-180).max(180).required()
        })
            .required(),
        area: Joi.string()
            .required()
            .empty('')
            .label(i18n.t("Area"))
            .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),

    }).required(),
    workhours: Joi.object().required(),
    operationType: Joi.string()
        .empty('')
        .label(i18n.t("Working hours system"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` })
        .required()
})
// .keys({
//     0: Joi.array().items(Joi.string().required()),
//     1: Joi.array().items(Joi.string().required()),
//     2: Joi.array().items(Joi.string().required()),
//     3: Joi.array().items(Joi.string().required()),
//     4: Joi.array().items(Joi.string().required()),
// })
// export const UPDATE_SERVICEPOINT_SCHEMA = Joi.object({
//     name: Joi.string()
//         .required()
//         .empty('')
//         .label(i18n.t("Full Name"))
//         .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
//     phone: Joi.string()
//         .label(i18n.t("Phone"))
//         .empty('')
//         .messages({
//             'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
//         })
//         .custom((value, helper) => {
//             const parsedPhone = parsePhoneNumber(value, { extract: true });
//             if (!parsedPhone || !parsedPhone.isValid())
//                 return helper.message(i18n.t("validationErrors.isValidPhone"));
//             return true
//         }),
//     address: Joi.object().keys({
//         city: Joi.string()
//             .required()
//             .empty('')
//             .label(i18n.t("City"))
//             .messages({
//                 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
//             }),
//         details: Joi.string()
//             .empty('')
//             .label(i18n.t("Details"))
//             .messages({
//                 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
//             }),
//         location: Joi.object().keys({
//             coordinates: Joi.array()
//                 .required()
//                 .messages({
//                     'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
//                 })
//         }).required()
//     }).required()
// })